var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_305",
    "data-name": "Raggruppa 305",
    transform: "translate(-4226 -9847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_298",
    "data-name": "Raggruppa 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_776",
    "data-name": "Tracciato 776",
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256,114.616,0,256,0,512,114.616,512,256Z",
    transform: "translate(4226 9847)",
    fill: "#66666e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_777",
    "data-name": "Tracciato 777",
    d: "M389.292,218.668a37.323,37.323,0,0,1,15.124,71.448,73.515,73.515,0,0,1,.876,11.216c0,57.44-66.86,104-149.332,104s-149.336-46.56-149.336-104a73.543,73.543,0,0,1,.892-11.292,37.314,37.314,0,1,1,41.1-60.964c25.844-18.62,61.568-30.532,101.3-31.632l18.992-89.28a6.674,6.674,0,0,1,7.908-5.136l62.04,13.188a26.648,26.648,0,1,1-2.728,13.052l-55.564-11.812-17,80.012c39.16,1.368,74.32,13.26,99.84,31.676A37.167,37.167,0,0,1,389.292,218.668ZM288,282.672A26.666,26.666,0,1,0,314.668,256,26.7,26.7,0,0,0,288,282.672Zm31.36,70.46c-18.2,18.176-53.076,19.588-63.328,19.588s-45.136-1.412-63.316-19.592a6.911,6.911,0,0,1,9.776-9.772c11.472,11.472,36.012,15.544,53.54,15.544s42.072-4.072,53.564-15.548a6.91,6.91,0,1,1,9.764,9.78ZM197.344,256A26.666,26.666,0,1,0,224,282.668,26.7,26.7,0,0,0,197.344,256Z",
    transform: "translate(4226 9847)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.cf23b45b4506206d7e9a3bb1aec4adbe.svg";
export { ForwardRef as ReactComponent };